import apiFetch from '../../apiFetch'

export default function (dossierId, body, token) {
  return apiFetch({ endPoint: `dossier/stock/${dossierId}/DossierRatingComponent`, body: body, method: 'PUT', token: token })
}
